import { render, staticRenderFns } from "./ProfilePasswordCard.vue?vue&type=template&id=50527343&scoped=true"
import script from "./ProfilePasswordCard.vue?vue&type=script&lang=js"
export * from "./ProfilePasswordCard.vue?vue&type=script&lang=js"
import style0 from "./ProfilePasswordCard.vue?vue&type=style&index=0&id=50527343&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50527343",
  null
  
)

export default component.exports